import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { DocumentNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addDocument = (state: SyfoAppState, action: PayloadAction<DocumentNode>) => {
  if (state.currentVault) {
    state.currentVault.data.documents.push(action.payload);
  }
};

export const updateDocument = (state: SyfoAppState, action: PayloadAction<{ id: string; document: Partial<DocumentNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.documents, action.payload.id, action.payload.document);
  }
};

export const removeDocument = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.documents = state.currentVault.data.documents.filter((d) => d.id !== action.payload);
  }
};
